module.exports = __webpack_public_path__ + "static/media/logo3.3d44414c.png";